import { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { isNull } from 'lodash';
import { agylePref } from '../../../../store/reducers/preferences';
import { FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getConfig } from '../../../../util/configUtil';

const DEFAULT_STATE = {
    dorInClinicalNotes: 'ask',
};
const DefaultDoRPreview = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const agylePreference = useSelector(agylePref);

    // config
    const splitScreen = getConfig('modules.splitScreen.enabled', false);

    const [mode, setMode] = useState(
        !isNull(agylePreference?.dorInClinicalNotes) ? agylePreference?.dorInClinicalNotes : DEFAULT_STATE.dorInClinicalNotes,
    );

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setMode(DEFAULT_STATE.dorInClinicalNotes);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (_e, val) => {
        setMode(val);
        props.onChange('dorInClinicalNotes', val);
    };

    return (
        <div>
            <FormLabel>{t('Select the default behaviour of open document of record in clinical notes')}</FormLabel>

            <RadioGroup value={mode} row onChange={handleChange}>
                <FormControlLabel value="newTab" control={<Radio />} label={t('New Tab')} />
                <FormControlLabel value="iframe" control={<Radio />} label={t('View Document')} />
                {splitScreen && <FormControlLabel value="splitScreen" control={<Radio />} label={t('Split Screen')} />}
                <FormControlLabel value="ask" control={<Radio />} label={t('Always ask')} />
            </RadioGroup>
        </div>
    );
});

export default DefaultDoRPreview;
